/**
 * 一张抽奖票的号码。
 *
 * <p><b>票号 0 起</b>：第一张票是 `000`（2026-09-24 PM 拍板）。接口原样透出库里
 * 的号，所以这里不做任何加减——线上值就是玩家该看到的那个数。
 *
 * <p><b>这个模块存在的理由是「不许再抄一遍」。</b> 在它之前，
 * `pages/tabs/WalletPage.tsx` 和 `features/sorteios/DrawEntriesSheet.tsx` 各有一个
 * 私有的 `serialNumber`，后者的注释还明写着「照抄同一段算法，不是复用同一份
 * 代码」。票号从 1 起改成 0 起时只改到了 `drawnSerialFrom` 那条链，这两份抄件
 * 留着 `+ 1`，把参与名单、我的票、中奖名单、开奖动画、按票号搜索——一共 14 个
 * 显示点的票号全部印高了一位（2026-09-25 复核）。抄件不会一起被改，所以只留
 * 一份，并且有测试。
 */

/**
 * 线上那个票号，规整成一个整数。
 *
 * <p>缺失或非数字一律算 0 号，而不是让 `NaN` 印到屏幕上。真正「没有票号」的
 * 情形由调用方判断要不要整段不渲染，不靠这里返回一个假值。
 */
export function ticketSerial(serial: number | string | null | undefined): number {
  const value = Number(serial ?? 0);
  return Number.isFinite(value) ? Math.trunc(value) : 0;
}

/**
 * 票号的显示形式：补零到三位，**不带 `#`**。
 *
 * <p>`#` 在这个 App 里一律是「第几期」（房间、Pick 4、账本都这么用）。票号也带
 * `#` 的话，两个「#三位数」在同一屏上没人分得清哪个是期、哪个是票
 * （2026-09-18 PM）。前导零是为了一列排下来对齐、看着像编号而不像张数；号码超过
 * 三位时照原样给全，补零不是限长。
 */
export function ticketLabel(serial: number | string | null | undefined): string {
  return String(ticketSerial(serial)).padStart(3, '0');
}
